import * as React from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import * as Paths from "@tunnel-enums/index";
import { RoutesModels } from "@tunnel-models/routes";
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";
import Login from "@tunnel-components/@pages/login";
import FogetPassWord from "@tunnel-components/@pages/fogetPassword";
import ResetPassword from "@tunnel-components/@pages/resetPassword";
import TunnelWatchHome from "@tunnel-components/@pages/incidents/home";
import FicheIncident from "@tunnel-components/@pages/incidents/fiche";
import E404 from "@tunnel-components/@pages/e404/component";
import Versionning from "@tunnel-components/@pages/administration/versionning";
import Users from "@tunnel-components/@pages/administration/users";
import Explorer from "@tunnel-components/@pages/explorer/home";
import SystemsHome from "@tunnel-components/@pages/supervision/systems/home";
import SystemsConfig from "@tunnel-components/@pages/supervision/systems/config";
import Display from "@tunnel-components/@pages/supervision/display/home";
import Impacts from "@tunnel-components/@pages/supervision/incident/home";
import Simulator from "@tunnel-components/@pages/supervision/simulator/home";
import ExtractorVideo from "@tunnel-components/@pages/tools/extractor/home";
import CameraCreated from "@tunnel-components/@pages/supervision/camera/created";
import Inhibitions from "@tunnel-components/@pages/supervision/inhibitions/home";
import CameraHome from "@tunnel-components/@pages/supervision/camera/home";
import TmdLapiExplorer from "@tunnel-components/@pages/lapi-tmd/explorer";
import TmdLapiCameras from "@tunnel-components/@pages/lapi-tmd/cameras";
import TmdLapiIncidents from "@tunnel-components/@pages/lapi-tmd/incidents";
import CameraSettings from "@tunnel-components/@pages/supervision/camera/settings";
import CameraSegmentation from "@tunnel-components/@pages/supervision/camera/segmentation/home";
import OneCameraSegmentation from "@tunnel-components/@pages/supervision/camera/segmentation/onecamera";
import CitilogIncidents from "@tunnel-components/@pages/tools/citilogIncident/home";
import Administration from "@tunnel-components/@pages/administration/home";
import Statistic from "@tunnel-components/@pages/supervision/camera/statistics";
/**
 * CallTunnelRoutes - Le component retourne les routes
 * il y'a des routes protégé avec verification du token
 * @class CallTunnelRoutes
 * @extends React.Component<RoutesModels>
 */
class CallTunnelRoutes extends React.Component<RoutesModels> {
  /**
   * @constructor
   * @param { RoutesModels } props  - any
   */
  constructor(props: RoutesModels) {
    super(props);
    this.state = {};
  }
  /**
   * Cycle de vie d'un composant react
   * @method render
   * @param {  }
   * @return { JSX.Element }
   */
  public render(): JSX.Element {
    /** Redirection après l'authentification */
    /** @return { Route} */
    const PrivateRoute = ({ component: Component, ...rest }: any) => {
      const routeComponent = (props: any) =>
        Utils.verifIsTokenIsValidOrExpired() ? (
          React.createElement(Component, props)
        ) : (
          <Redirect to={{ pathname: Paths.PathsNamesEnums.LOGIN }} />
        );
      return <Route {...rest} render={routeComponent} />;
    };

    /** redirection si l'utilisateur est déjà authentifié */
    /** @return { Route} */
    const RedirectTo = ({ component: Component, ...rest }: any): any => {
      const routeComponent = (props: any) =>
        Utils.verifIsTokenIsValidOrExpired() ? (
          <Redirect to={{ pathname: Paths.PathsNamesEnums.TUNNELWATCH }} />
        ) : (
          React.createElement(Component, props)
        );

      return <Route {...rest} render={routeComponent} />;
    };

    /** Attribué un rôle à l'utilisateur */
    const User = Utils.createdUserRoles();

    return (
      <Switch>
        <RedirectTo
          exact={true}
          path={Paths.PathsNamesEnums.LOGIN}
          component={Login}
        />
        <RedirectTo
          exact={true}
          path={Paths.PathsNamesEnums.FOGETPASSWORD}
          component={FogetPassWord}
        />
        <RedirectTo
          exact={true}
          path={Paths.PathsNamesEnums.RESETPASSWORD}
          component={ResetPassword}
        />

        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.HOMEVIEWINCIDENTS,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.TUNNELWATCH}
            component={TunnelWatchHome}
          />
        )}

        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.HOMEVIEWINCIDENTSDETAILS,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.TUNNELWATCHONECAMERA}
            component={FicheIncident}
          />
        )}
        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.ADMINISTRATIONHOME,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.VERSIONNING}
            component={Versionning}
          />
        )}
        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.ADMINISTRATIONUSERSLISTS,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.USERS}
            component={Users}
          />
        )}
        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.EXPLORERVIEWLISTS,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.EXPLORE}
            component={Explorer}
          />
        )}
        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.ADMINISTRATIONHOME,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.ADMINISTRATION}
            component={Administration}
          />
        )}
        {/*{Utils.simpleAuthorizationHasRole(User,[Enums.AuthorizationRolesEnums.ROLE_SUPER_ADMIN])  && <PrivateRoute*/}
        {/*exact={true} */}
        {/*path={Paths.PathsNamesEnums.DASHBOARD}*/}
        {/*component={Dashboard}*/}
        {/*/>}*/}

        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.INCIDENTSETTINGSVIEW,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.INCIDENTS}
            component={Impacts}
          />
        )}

        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.CAMERASTATIC,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.STATISTICS}
            component={Statistic}
          />
        )}

        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.INHIBITIONVIEWLISTS,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.INHIBITIONS}
            component={Inhibitions}
          />
        )}
        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.SYSTEMVIEWTUBES,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.SYSTEMSHOME}
            component={SystemsHome}
          />
        )}
        <PrivateRoute
          exact={true}
          path={Paths.PathsNamesEnums.SYSTEMSCONFIGID}
          component={SystemsConfig}
        />
        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.TMDLAPIVIEWLIST,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.TMDLAPIEXPLORER}
            component={TmdLapiExplorer}
          />
        )}
        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.TMDLAPIVIEWLIST,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.TMDLAPIINCIDENTS}
            component={TmdLapiIncidents}
          />
        )}
        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.TMDLAPIVIEWLIST,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.TMDLAPICAMERAS}
            component={TmdLapiCameras}
          />
        )}

        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.CAMERALISTS,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.CAMERAHOME}
            component={CameraHome}
          />
        )}
        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.CAMERASEGMENTATIONVIEW,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.CAMERASEGMENTATION}
            component={CameraSegmentation}
          />
        )}

        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.CAMERASEGMENTATIONVIEW,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.ONECAMERASEGMENTATION}
            component={OneCameraSegmentation}
          />
        )}

        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.CAMERADETAILS,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.CAMERASETTINGS}
            component={CameraSettings}
          />
        )}
        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.CAMERAADDED,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.CAMERACREATED}
            component={CameraCreated}
          />
        )}
        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.SIMULATORCREATED,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.SIMULATOR}
            component={Simulator}
          />
        )}

        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.EXTRACTEDTHALESSEQUENCE,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.EXTRACTOR}
            component={ExtractorVideo}
          />
        )}
        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.CITILOGLISTS,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.CITILOGINCIDENT}
            component={CitilogIncidents}
          />
        )}
        {Utils.simpleAuthorizationIsAllowed(User, [
          Enums.AuthorizationRightsEnums.AFFICHAGEINCIDENTSPARAM,
        ]) && (
          <PrivateRoute
            exact={true}
            path={Paths.PathsNamesEnums.DISPLAY}
            component={Display}
          />
        )}

        <PrivateRoute
          exact={true}
          path={Paths.PathsNamesEnums.E404}
          component={E404}
        />
      </Switch>
    );
  }
}

/**
 * Exporter cette module à fin d'être utiliser par les
 * autres modules de l'application
 * @function withRouter        -  High Order Component   -
 * @export CallTunnelRoutes
 */
export default withRouter(CallTunnelRoutes);



// WEBPACK FOOTER //
// ./src/apps/tunnel/routes/index.tsx